export const VideoPlayIcon = () => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7774_36098)">
<circle cx="22.2656" cy="22.7148" r="14.7812" fill="white"/>
<path d="M22.2656 0.542969C10.0393 0.542969 0.09375 10.4895 0.09375 22.7148C0.09375 34.9402 10.0393 44.8867 22.2656 44.8867C34.4919 44.8867 44.4375 34.9402 44.4375 22.7148C44.4375 10.4895 34.4919 0.542969 22.2656 0.542969ZM31.0799 23.4916L18.1463 31.8061C17.9974 31.9023 17.8238 31.9533 17.6465 31.9532C17.4949 31.9532 17.3416 31.9152 17.2045 31.8404C17.0586 31.7611 16.9369 31.6438 16.8521 31.5011C16.7673 31.3583 16.7226 31.1953 16.7227 31.0293V14.4004C16.7227 14.0621 16.9067 13.7517 17.2045 13.5893C17.4968 13.4287 17.863 13.4386 18.1463 13.6236L31.0799 21.938C31.3434 22.1076 31.5039 22.4009 31.5039 22.7148C31.5039 23.0288 31.3434 23.322 31.0799 23.4916Z" fill="#EB473D"/>
</g>
<defs>
<clipPath id="clip0_7774_36098">
<rect width="44.3437" height="44.3437" fill="white" transform="translate(0.09375 0.542969)"/>
</clipPath>
</defs>
</svg>

);
